import { useState } from 'react'

const SiteIcon = ({ className = '', url }) => {
  const [isErred, setIsErred] = useState(false)

  if (!url) {
    return <div className={className} />
  }

  if (isErred) {
    return <div className={className} />
  }

  return (
    <img
      className={className}
      src={'https://www.google.com/s2/favicons?domain=' + url}
      alt="site logo"
      onError={() => setIsErred(true)}
    />
  )
}

export default SiteIcon
